<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('leave_app') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/application/create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr class="blue">
                                <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                                <th>{{$t('employee_name')}}</th>
                                <th>{{$t('leave_category')}}</th>
                                <th class="text-center">{{$t('type')}}</th>
                                <th class="text-center">{{$t('qty_day')}}</th>
                                <th class="text-center">{{$t('qty_hour')}}</th>
                                <th class="text-center">{{$t('date')}}</th>
                                <th class="text-center">{{$t('from_date')}}</th>
                                <th class="text-center">{{$t('to_date')}}</th>
                                <th>{{$t('reason')}}</th>
                                <th class="text-center" style="width: 80px;">{{$t('status')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{name: 'leave_application_preview', params: {id: ret.LeaveApplication.Id}}">{{ret.Employee.Num + ' : ' + ret.Employee.KhmerName}}</router-link></td>
                                <td>{{ret.LeaveType.Code}} : {{ret.LeaveType.Description}}</td>
                                <td class="text-center">{{ret.LeaveApplication.ApplyType}}</td>
                                <td class="text-center">{{ret.LeaveApplication.TakenDays}}</td>
                                <td class="text-center">{{ret.LeaveApplication.TakenHours}}</td>
                                <td class="text-center">{{$format(ret.LeaveApplication.SubmittedDate,'DD/MM/YYYY')}}</td>
                                <td class="text-center">{{$format(ret.LeaveApplication.FromDate,'DD/MM/YYYY')}}</td>
                                <td class="text-center">{{$format(ret.LeaveApplication.ToDate,'DD/MM/YYYY')}}</td>
                                <td>{{ret.LeaveApplication.Reason}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.LeaveApplication.Status)"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit"
                                      v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                                      hide-goto-end-buttons
                                      @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function () {
            return {
                query: {
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    Text: ''
                },
                list: []
            }
        },
        created: function () {
            this.toList();
        },
        methods: {
            toList() {
                let loading = this.$loading.show();
                this.$api().post('leave/application/list', this.query).then(res => {
                    if (this.$isValid(res)) {
                        this.list = res.data.Json.Applications;
                        this.query.Total = res.data.Total;
                    }
                }).finally(function () {
                    loading.hide();
                });
            }
        }
    }
</script>